import { render, staticRenderFns } from "./TerritorySales.vue?vue&type=template&id=8996ef1a&"
import script from "./TerritorySales.vue?vue&type=script&lang=js&"
export * from "./TerritorySales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports